module.exports = __webpack_public_path__ + "img/c.5bf34c83.jpg";